import { Reducer } from "redux";
import { UserState } from "./@types";
import { TAction } from "loop-front";
import { OUser } from "./Model";
import {userCommentsParser, userParser} from './userParser';
import utilities from "Resources/Utils";

export const RUser: Reducer<UserState, TAction> = (state = {}, action): UserState => {
    const { LIST_RECEIVED, SINGLE_ITEM_RECEIVED, ENTITY_OF_ITEM_RECEIVED, ACTIVITY_POST_SUCCESS, } = OUser.Actions;
    switch (action.type) {
        case OUser.Actions.APP_USER_RECEIVED: return { ...state, appUser: { ...action.data, roles: ['ADMIN'] } };
        case ENTITY_OF_ITEM_RECEIVED: return {...state,  commentList: (action.data || []).map(userCommentsParser) }
        case LIST_RECEIVED: return { ...state, list: (action.data || []).map(userParser) }
        case SINGLE_ITEM_RECEIVED: return { ...state, user: userParser(action.data) }
        case ACTIVITY_POST_SUCCESS: {
            switch (action.activity) {
                case OUser.Activities.TOGGLE_PUBLISH: {
                    return {
                        ...state,
                        user: state.user?.id === action.data.id ? { ...state.user, ...userParser(action.data) } : undefined,
                        list: utilities.updateItemList(state.list, userParser(action.data), 'UPDATE')
                    }
                }
                case OUser.Activities.LOGOUT: return { ...state, appUser: undefined }
                default: return state;
            }
        }
        default: return { ...state };
    }
}